import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-itau',
  templateUrl: './e-itau.component.html',
  styleUrls: ['./e-itau.component.scss']
})
export class EItauComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
